import styled, { css } from "styled-components";
import { setLightness } from "polished";
import theme from "../style/theme";
import { ILightDarkStyleProps, IInfoStyleProps, ICenterStyleProps, IAlertStyleProps } from "./interfaces";

const $color2 = setLightness(0.27, theme.c.dark);

export const StyledArticle = styled.div<ILightDarkStyleProps>`
    overflow: hidden;
    padding: 0 16px;
    position: relative;
    ${p =>
        p.light &&
        css`
            background-color: ${p => p.theme.mode === "dark" ? p.theme.c.snow : p.theme.c.light};
        `}
    ${p =>
        p.dark &&
        css`
            background-color: ${$color2};
        `}
`;

export const H2 = styled.h2<ILightDarkStyleProps>`
    text-align: center;
    font-size: 40px;
    font-variant: normal;
    text-transform: uppercase;
    margin-bottom: 10px;
    ${p =>
        p.dark &&
        css`
            color: ${p => p.theme.c.light};
        `}

    ${p =>
        p.theme.xs(css`
            font-size: 36px;
        `)}
`;

export const H3 = styled.h3<IInfoStyleProps>`
    text-align: center;
    font-size: 36px;
    font-variant: small-caps;
    margin-bottom: 10px;
    ${p =>
        p.info &&
        css`
            color: ${p => p.theme.c.info};
        `}
    ${p =>
        p.theme.xs(css`
            font-size: 32px;
        `)}
`;

export const H4 = styled.h4<ICenterStyleProps>`
    ${p =>
        p.center &&
        css`
            text-align: center;
        `}
    font-size: 28px;
    margin: 12px auto;
    ${p =>
        p.theme.xs(css`
            font-size: 24px;
        `)}
`;

export const P1 = styled.p<ICenterStyleProps & ILightDarkStyleProps>`
    ${p =>
        p.center &&
        css`
            text-align: center;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
        `}

    ${p =>
        p.dark &&
        css`
            color: ${p => p.theme.c.snowOnActive};
        `}
    font-size: 20px;
    font-weight: 400;
    line-height: 1.33;
`;

export const P2 = styled.p<ICenterStyleProps & ILightDarkStyleProps & IAlertStyleProps>`
    ${p =>
        p.center &&
        css`
            text-align: center;
            max-width: 900px;
            margin-left: auto;
            margin-right: auto;
        `}
    ${p =>
        p.dark &&
        css`
            color: ${p => p.theme.c.snowOnActive};
        `}
    ${p =>
        p.alert &&
        css`
            color: ${p => p.theme.c.incorrect};
        `}
    
    font-size: 18px;
    font-weight: 400;
    line-height: 1.33;
`;
